import {useQuery} from '@apollo/react-hooks';

import type {AiFeatureType} from 'nutshell-graphql-types';
import type {
    GetAiFeatureEnabled as GetAiFeatureEnabledQuery,
    GetAiFeatureEnabledVariables as GetAiFeatureEnabledQueryVariables,
} from 'nutshell-graphql-types';

import GET_AI_FEATURE_ENABLED from '../queries/get-ai-feature-enabled.graphql';

export function useIsAiFeatureEnabled(featureType: AiFeatureType): {
    isEnabled: boolean;
    isLoading: boolean;
} {
    const {data, loading} = useQuery<GetAiFeatureEnabledQuery, GetAiFeatureEnabledQueryVariables>(
        GET_AI_FEATURE_ENABLED,
        {
            variables: {type: featureType},
        }
    );

    const isEnabled =
        data?.aiFeatureUsage?.features?.some(
            (feature) => feature.type === featureType && feature.isEnabled
        ) ?? false;

    return {isEnabled, isLoading: loading && !data};
}
